import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableExtendedCustomsContentTypes = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableExtendedCustomsContentTypes);
};
